import React, { useState, useEffect } from "react";
import "./configuration-option.module.css";
import SVGComponent from "./SVGComponent";

interface ConfiguratorOptionProps {
  imageMobile: string;
  imageDesktop: string;
  label?: string;
  onClick: () => void;
  isSelected?: boolean;
  title?: string;
  isCustomBorder?: boolean;
  SVGComponent?: React.FC;
  key?: string,
  backgroundColour?: string
}

const ConfiguratorOption: React.FC<ConfiguratorOptionProps> = ({
  imageMobile,
  imageDesktop,
  label,
  onClick,
  isSelected,
  title,
  isCustomBorder,
  SVGComponent,
  key,
  backgroundColour
}) => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  const handleImageLoad = () => setLoading(false);
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder.png`;
    setLoading(false);
  };

  console.log(window.devicePixelRatio);


  useEffect(() => {
    let interval: NodeJS.Timer | null = null;
    if (loading) {
      interval = setInterval(() => {
        setProgress((prev) => (prev < 100 ? prev + 10 : 100));
      }, 100);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [loading]);

  return (
    <div
      key={label}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-selected={isSelected}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
      className={`relative pb-2 p-2  bg-gray-100 rounded-[25px] cursor-pointer overflow-hidden flex flex-col items-center  aspect-square  lg:p-8 ${isSelected ? "border-4 border-red-600" : "border-4 border-gray-100"
        }`}
    >
      {title && (
        <p
          className="text-center text-xs sm:text-base md:text-lg font-medium  text-black leading-snug mb-2 sm:mb-4 "
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </p>
      )}

      {!SVGComponent && loading && (
        <div className="absolute top-0 left-0 w-full h-1 bg-gray-300">
          <div
            className="h-full bg-white-600 transition-all progress-bar"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      )}

      {/* Image Container */}
      <div
        className={`flex items-center justify-center ${isCustomBorder ? "box" : ""}`}
        style={{
          width: "100%", // Full width for consistent alignment
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          background: isCustomBorder ? backgroundColour || "#B9B8B8" : "",
          overflow: "hidden"
        }}
      >


        {SVGComponent ? (
          <SVGComponent />
        ) : (
          <picture>
            {/* For PNG Images */}
            {imageMobile.endsWith(".png") && (
              <source
                srcSet={`
                  ${imageMobile} 1x,
                  ${imageMobile.replace(".png", "@2x.png")} 2x,
                  ${imageMobile.replace(".png", "@3x.png")} 3x
                `}
                media="(max-width: 767px)"
                type="image/png"
              />
            )}

            {imageMobile.endsWith(".svg") && (
              <source
                srcSet={imageMobile}
                media="(max-width: 767px)"
                type="image/svg+xml"
              />
            )}

            <source
              srcSet={imageDesktop}
              media="(min-width: 768px)"
              type="image/svg+xml"
            />

            <source
              srcSet={`
                ${imageDesktop} 1x,
                ${imageDesktop.replace(".png", "@2x.png")} 2x,
                ${imageDesktop.replace(".png", "@3x.png")} 3x
              `}
              media="(min-width: 768px)"
              type="image/svg+xml"

            />

            <source
              srcSet={`${imageMobile}`}
              media="(max-width: 767px)"
              type="image/webp"
            />

            <img
              src={imageMobile}
              alt={label || "Image"}
              className={`w-full h-auto max-h-full ${loading ? "opacity-0" : "opacity-100"
                } transition-opacity duration-300`}
              loading="lazy"
              onLoad={handleImageLoad}
              onError={handleImageError}

            />
          </picture>
        )}
      </div>

      {label && (
        <p
          className="pt-4 mt-2 text-center text-sm sm:text-base md:text-lg lg:text-xl font-medium text-black"
          style={{
            // wordBreak: "break-word",
            whiteSpace: "normal", // Allow wrapping
            textOverflow: "ellipsis",
          }}
        >
          {label}
        </p>
      )}
    </div>
  );

};

export default ConfiguratorOption;
